/**
 * VenueData.ts
 * Static list of TAB Venues latitude and longitude
 * Refer to the wiki: https://rwwa.atlassian.net/wiki/spaces/FR/pages/2460319784/Customer+Location+Geo+Location
 * for more detailed information on data sources
 * */
export interface Venue {
  location_id: number
  venue_id: string
  opening_type: string
  location_name: string
  address: string
  latitude: number
  longitude: number
  radius: number
}

export const venueData: Venue[] = [
  {
    location_id: 1,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Perth',
    address: '120 Barrack Street, PERTH WA 6000, Australia',
    latitude: -31.953191,
    longitude: 115.861193,
    radius: 25,
  },
  {
    location_id: 2,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Account Contact Centre-GMEE',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.909567,
    longitude: 115.806477,
    radius: 25,
  },
  {
    location_id: 5,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Mt Hawthorn',
    address: '118 Hobart Street, MOUNT HAWTHORN WA 6016, Australia',
    latitude: -31.921772,
    longitude: 115.840478,
    radius: 25,
  },
  {
    location_id: 6,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Osborne Park',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.909859,
    longitude: 115.807368,
    radius: 25,
  },
  {
    location_id: 8,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Northbridge',
    address: 'Unit 1 129 James Street, NORTHBRIDGE WA 6003, Australia',
    latitude: -31.948261,
    longitude: 115.857369,
    radius: 25,
  },
  {
    location_id: 9,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Perth',
    address: '860 Hay Street, PERTH WA 6000, Australia',
    latitude: -31.952408,
    longitude: 115.853829,
    radius: 25,
  },
  {
    location_id: 10,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Workshop Qa',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.909235,
    longitude: 115.806708,
    radius: 25,
  },
  {
    location_id: 11,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wembley',
    address: '344 Cambridge Street, WEMBLEY WA 6014, Australia',
    latitude: -31.940526,
    longitude: 115.810049,
    radius: 40,
  },
  {
    location_id: 12,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Scarborough',
    address: '240 West Coast Highway, SCARBOROUGH WA 6019, Australia',
    latitude: -31.896273,
    longitude: 115.758908,
    radius: 25,
  },
  {
    location_id: 13,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Innaloo',
    address: '2 Morris Road, INNALOO WA 6018, Australia',
    latitude: -31.889331,
    longitude: 115.792989,
    radius: 40,
  },
  {
    location_id: 14,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Osborne Park',
    address: '216 Main Street, OSBORNE PARK WA 6017, Australia',
    latitude: -31.897034,
    longitude: 115.828836,
    radius: 40,
  },
  {
    location_id: 15,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'West Perth',
    address: '331 Bulwer Street, WEST PERTH WA 6005, Australia',
    latitude: -31.938203,
    longitude: 115.856963,
    radius: 25,
  },
  {
    location_id: 16,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Malaga',
    address: 'Unit 3 9 Bonner Drive, MALAGA WA 6090, Australia',
    latitude: -31.850522,
    longitude: 115.878416,
    radius: 25,
  },
  {
    location_id: 22,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Fremantle',
    address: 'Unit Shop 10 17-23 Collie Street, FREMANTLE WA 6160, Australia',
    latitude: -32.056241,
    longitude: 115.747066,
    radius: 15,
  },
  {
    location_id: 23,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Greenwood',
    address: '349 Warwick Road, GREENWOOD WA 6024, Australia',
    latitude: -31.83305,
    longitude: 115.803195,
    radius: 30,
  },
  {
    location_id: 24,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Yokine',
    address: 'Unit T22/22A 6 Wanneroo Road, YOKINE WA 6060, Australia',
    latitude: -31.910738,
    longitude: 115.847619,
    radius: 15,
  },
  {
    location_id: 25,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Balcatta',
    address: '501 Wanneroo Road, BALCATTA WA 6021, Australia',
    latitude: -31.861784,
    longitude: 115.826368,
    radius: 30,
  },
  {
    location_id: 30,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Palmyra',
    address: 'Unit Shop 9 265 Canning Highway, PALMYRA WA 6157, Australia',
    latitude: -32.038687,
    longitude: 115.77633,
    radius: 15,
  },
  {
    location_id: 33,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Spearwood',
    address: '6-Feb Lancaster Street, SPEARWOOD WA 6163, Australia',
    latitude: -32.095008,
    longitude: 115.783295,
    radius: 15,
  },
  {
    location_id: 36,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Maylands',
    address: '223 Railway Parade, MAYLANDS WA 6051, Australia',
    latitude: -31.927489,
    longitude: 115.891627,
    radius: 30,
  },
  {
    location_id: 37,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Cannington',
    address: '1382 Albany Highway, CANNINGTON WA 6107, Australia',
    latitude: -32.018346,
    longitude: 115.935828,
    radius: 15,
  },
  {
    location_id: 39,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'East Victoria Park',
    address: '948 Albany Highway, EAST VICTORIA PARK WA 6101, Australia',
    latitude: -31.989155,
    longitude: 115.906909,
    radius: 25,
  },
  {
    location_id: 41,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Belmont',
    address: '174 Wright Street, CLOVERDALE WA 6105, Australia',
    latitude: -31.966486,
    longitude: 115.931549,
    radius: 25,
  },
  {
    location_id: 42,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Carlisle',
    address: '174 Rutland Avenue, CARLISLE WA 6101, Australia',
    latitude: -31.979702,
    longitude: 115.910795,
    radius: 25,
  },
  {
    location_id: 43,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Bentley',
    address: 'Tate Street, BENTLEY WA 6102, Australia',
    latitude: -31.999837,
    longitude: 115.918268,
    radius: 35,
  },
  {
    location_id: 44,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Queens Park',
    address: '156 Railway Parade, QUEENS PARK WA 6107, Australia',
    latitude: -32.00718,
    longitude: 115.939213,
    radius: 15,
  },
  {
    location_id: 45,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Waterford',
    address: '230 Manning Road, WATERFORD WA 6152, Australia',
    latitude: -32.01186,
    longitude: 115.886007,
    radius: 15,
  },
  {
    location_id: 48,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Como',
    address: '241 Canning Highway, COMO WA 6152, Australia',
    latitude: -31.98825,
    longitude: 115.870725,
    radius: 30,
  },
  {
    location_id: 50,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'South Perth',
    address: 'Unit Shop 1A 25 Mends Street, SOUTH PERTH WA 6151, Australia',
    latitude: -31.97226,
    longitude: 115.852541,
    radius: 15,
  },
  {
    location_id: 52,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Kwinana',
    address: 'Unit P2-1 4 Chisham Avenue, KWINANA TOWN CENTRE WA 6167, Australia',
    latitude: -32.244242,
    longitude: 115.814061,
    radius: 15,
  },
  {
    location_id: 55,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Girrawheen',
    address: '55 Templeton Crescent, GIRRAWHEEN WA 6064, Australia',
    latitude: -31.83689,
    longitude: 115.830203,
    radius: 25,
  },
  {
    location_id: 56,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Booragoon',
    address: '125 Riseley Street, BOORAGOON WA 6154, Australia',
    latitude: -32.035365,
    longitude: 115.837488,
    radius: 15,
  },
  {
    location_id: 60,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Warwick',
    address: 'Unit Shop FS004 Beach Road, WARWICK WA 6024, Australia',
    latitude: -31.845054,
    longitude: 115.810171,
    radius: 15,
  },
  {
    location_id: 61,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Peppermint Grove',
    address: 'Unit Shop 2 484 Stirling Highway, PEPPERMINT GROVE WA 6011, Australia',
    latitude: -31.999079,
    longitude: 115.762474,
    radius: 15,
  },
  {
    location_id: 62,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Dianella',
    address: '162 Alexander Drive, DIANELLA WA 6059, Australia',
    latitude: -31.894599,
    longitude: 115.870878,
    radius: 15,
  },
  {
    location_id: 65,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Morley',
    address: '250 Walter Road, MORLEY WA 6062, Australia',
    latitude: -31.895278,
    longitude: 115.896975,
    radius: 15,
  },
  {
    location_id: 66,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Midland',
    address: '30 Helena Street, MIDLAND WA 6056, Australia',
    latitude: -31.890457,
    longitude: 116.003002,
    radius: 15,
  },
  {
    location_id: 67,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bayswater',
    address: '78-80 Railway Parade, BAYSWATER WA 6053, Australia',
    latitude: -31.917295,
    longitude: 115.912889,
    radius: 45,
  },
  {
    location_id: 71,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Hillarys',
    address: 'Unit Shop 69 Whitfords Avenue, HILLARYS WA 6025, Australia',
    latitude: -31.796122,
    longitude: 115.750535,
    radius: 15,
  },
  {
    location_id: 73,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Beechboro',
    address: '165 Altone Road, BEECHBORO WA 6063, Australia',
    latitude: -31.869712,
    longitude: 115.94519,
    radius: 25,
  },
  {
    location_id: 79,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Karratha',
    address: 'Lot 1079 Searipple Road, KARRATHA WA 6714, Australia',
    latitude: -20.733238,
    longitude: 116.84711,
    radius: 25,
  },
  {
    location_id: 82,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Armadale',
    address: '8 Commerce Avenue, ARMADALE WA 6112, Australia',
    latitude: -32.152675,
    longitude: 116.013935,
    radius: 15,
  },
  {
    location_id: 84,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Mandurah',
    address: '33 Mandurah Terrace, MANDURAH WA 6210, Australia',
    latitude: -32.532803,
    longitude: 115.71986,
    radius: 15,
  },
  {
    location_id: 85,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Victoria Park',
    address: 'Unit Unit 2 4 King George Street, VICTORIA PARK WA 6100, Australia',
    latitude: -31.97343,
    longitude: 115.89622,
    radius: 15,
  },
  {
    location_id: 87,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Gosnells',
    address: 'Unit Shop 23 2164 Albany Highway, GOSNELLS WA 6110, Australia',
    latitude: -32.069112,
    longitude: 116.00067,
    radius: 15,
  },
  {
    location_id: 92,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Bunbury',
    address: 'Unit Unit 5 LOT 65 Sandridge Road, BUNBURY WA 6230, Australia',
    latitude: -33.336627,
    longitude: 115.663302,
    radius: 15,
  },
  {
    location_id: 94,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'York',
    address: '97 Avon Terrace, YORK WA 6302, Australia',
    latitude: -31.88974,
    longitude: 116.768091,
    radius: 35,
  },
  {
    location_id: 101,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Kalgoorlie',
    address: 'Maritana Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.739849,
    longitude: 121.466159,
    radius: 15,
  },
  {
    location_id: 103,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Boulder',
    address: '21-29 Forrest Street, BOULDER WA 6432, Australia',
    latitude: -30.785323,
    longitude: 121.488522,
    radius: 25,
  },
  {
    location_id: 104,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Non Prod: Training Centre',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.953177,
    longitude: 115.861092,
    radius: 25,
  },
  {
    location_id: 106,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Boulder',
    address: '62 Burt Street, BOULDER WA 6432, Australia',
    latitude: -30.782046,
    longitude: 121.489091,
    radius: 15,
  },
  {
    location_id: 108,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Geraldton',
    address: '441 Chapman Road, GERALDTON WA 6530, Australia',
    latitude: -28.736096,
    longitude: 114.624681,
    radius: 35,
  },
  {
    location_id: 109,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Broome',
    address: 'Carnarvon Street, BROOME WA 6725, Australia',
    latitude: -17.95502,
    longitude: 122.243513,
    radius: 15,
  },
  {
    location_id: 110,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Riverton',
    address: '355 High Road, RIVERTON WA 6148, Australia',
    latitude: -32.03918,
    longitude: 115.906684,
    radius: 15,
  },
  {
    location_id: 111,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Paraburdoo',
    address: '622 McRae Avenue, PARABURDOO WA 6754, Australia',
    latitude: -23.203742,
    longitude: 117.672088,
    radius: 25,
  },
  {
    location_id: 116,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'East Perth',
    address: '50 Bennett Street, EAST PERTH WA 6004, Australia',
    latitude: -31.958011,
    longitude: 115.87224,
    radius: 15,
  },
  {
    location_id: 120,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Hamilton Hill',
    address: '330 Carrington Street, HAMILTON HILL WA 6163, Australia',
    latitude: -32.075369,
    longitude: 115.780509,
    radius: 15,
  },
  {
    location_id: 122,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Dongara',
    address: '12 Moreton Terrace, DONGARA WA 6525, Australia',
    latitude: -29.251788,
    longitude: 114.933695,
    radius: 50,
  },
  {
    location_id: 125,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Como',
    address: '27 Manning Road, COMO WA 6152, Australia',
    latitude: -32.01464,
    longitude: 115.859702,
    radius: 30,
  },
  {
    location_id: 128,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Albany',
    address: '134 York Street, ALBANY WA 6330, Australia',
    latitude: -35.02628,
    longitude: 117.883896,
    radius: 15,
  },
  {
    location_id: 131,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wembley',
    address: '33 Herdsman Parade, WEMBLEY WA 6014, Australia',
    latitude: -31.927071,
    longitude: 115.815387,
    radius: 35,
  },
  {
    location_id: 134,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Mandurah',
    address: '176 Mandurah Terrace, MANDURAH WA 6210, Australia',
    latitude: -32.519262,
    longitude: 115.730318,
    radius: 40,
  },
  {
    location_id: 140,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Manjimup',
    address: '109 Giblett Street, MANJIMUP WA 6258, Australia',
    latitude: -34.239887,
    longitude: 116.147053,
    radius: 25,
  },
  {
    location_id: 150,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Mundaring',
    address: 'Cnr Nichol and Jacoby Street, MUNDARING WA 6073, Australia',
    latitude: -31.903456,
    longitude: 116.166046,
    radius: 35,
  },
  {
    location_id: 153,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Carnarvon',
    address: 'Unit Shop 6/7 29 Robinson Street, CARNARVON WA 6701, Australia',
    latitude: -24.883556,
    longitude: 113.656976,
    radius: 25,
  },
  {
    location_id: 154,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Rockingham Park',
    address: '1A Chalgrove Avenue, ROCKINGHAM WA 6168, Australia',
    latitude: -32.289144,
    longitude: 115.741015,
    radius: 15,
  },
  {
    location_id: 155,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Norseman',
    address: '90 Roberts Street, NORSEMAN WA 6443, Australia',
    latitude: -32.198857,
    longitude: 121.780744,
    radius: 25,
  },
  {
    location_id: 157,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Collie',
    address: '119 Throssell Street, COLLIE WA 6225, Australia',
    latitude: -33.360286,
    longitude: 116.152961,
    radius: 20,
  },
  {
    location_id: 161,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Carnarvon',
    address: '121 Olivia Terrace, CARNARVON WA 6701, Australia',
    latitude: -24.888305,
    longitude: 113.65644,
    radius: 25,
  },
  {
    location_id: 163,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Shoalwater Bay',
    address: '62 Second Avenue, SHOALWATER WA 6169, Australia',
    latitude: -32.292547,
    longitude: 115.710207,
    radius: 25,
  },
  {
    location_id: 164,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Geraldton',
    address: '19 Gregory Street, GERALDTON WA 6530, Australia',
    latitude: -28.776948,
    longitude: 114.606,
    radius: 35,
  },
  {
    location_id: 167,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Willetton',
    address: '71 Pinetree Gully Road, WILLETTON WA 6155, Australia',
    latitude: -32.058373,
    longitude: 115.881568,
    radius: 15,
  },
  {
    location_id: 169,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Geraldton',
    address: '79 Marine Terrace, GERALDTON WA 6530, Australia',
    latitude: -28.772741,
    longitude: 114.610386,
    radius: 25,
  },
  {
    location_id: 172,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Port Hedland',
    address: 'Cnr Lukis & Mcgregor Street, PORT HEDLAND WA 6721, Australia',
    latitude: -20.308831,
    longitude: 118.610201,
    radius: 25,
  },
  {
    location_id: 173,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Augusta',
    address: '53 Blackwood Avenue, AUGUSTA WA 6290, Australia',
    latitude: -34.316651,
    longitude: 115.160439,
    radius: 25,
  },
  {
    location_id: 176,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Spearwood',
    address: '432 Rockingham Road, SPEARWOOD WA 6163, Australia',
    latitude: -32.116094,
    longitude: 115.783099,
    radius: 25,
  },
  {
    location_id: 178,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Broome',
    address: 'Unit Shop 22 106 Frederick Street, BROOME WA 6725, Australia',
    latitude: -17.963431,
    longitude: 122.237547,
    radius: 50,
  },
  {
    location_id: 179,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'South Hedland',
    address: '14 Throssell Road, SOUTH HEDLAND WA 6722, Australia',
    latitude: -20.408949,
    longitude: 118.60003,
    radius: 40,
  },
  {
    location_id: 180,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Wanneroo',
    address: 'Unit 4 957 Wanneroo Road, WANNEROO WA 6065, Australia',
    latitude: -31.751751,
    longitude: 115.802645,
    radius: 25,
  },
  {
    location_id: 183,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Falcon',
    address: '627 Old Coast Road, FALCON WA 6210, Australia',
    latitude: -32.58233,
    longitude: 115.661612,
    radius: 25,
  },
  {
    location_id: 185,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kalbarri',
    address: '50 Grey Street, KALBARRI WA 6536, Australia',
    latitude: -27.710355,
    longitude: 114.165567,
    radius: 40,
  },
  {
    location_id: 186,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Dampier',
    address: '5 Neilson Place, DAMPIER WA 6713, Australia',
    latitude: -20.654957,
    longitude: 116.714002,
    radius: 45,
  },
  {
    location_id: 189,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Swan View',
    address: '305 Morrison Road, SWAN VIEW WA 6056, Australia',
    latitude: -31.885448,
    longitude: 116.040859,
    radius: 30,
  },
  {
    location_id: 190,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Mandurah',
    address: 'LOT 125 Gordon Road, MANDURAH WA 6210, Australia',
    latitude: -32.512406,
    longitude: 115.758284,
    radius: 150,
  },
  {
    location_id: 192,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'East Perth',
    address: 'Nelson Crescent, EAST PERTH WA 6004, Australia',
    latitude: -31.95679,
    longitude: 115.880905,
    radius: 150,
  },
  {
    location_id: 194,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Pannawonica',
    address: 'Pannawonica Drive, PANNAWONICA WA 6716, Australia',
    latitude: -21.639228,
    longitude: 116.324471,
    radius: 45,
  },
  {
    location_id: 195,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Crown Perth',
    address: '201 Great Eastern Highway, BURSWOOD WA 6100, Australia',
    latitude: -31.961461,
    longitude: 115.894972,
    radius: 200,
  },
  {
    location_id: 197,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bunbury',
    address: 'Cnr Brittain Rd & Bussell Highway, BUNBURY WA 6230, Australia',
    latitude: -33.359682,
    longitude: 115.64321,
    radius: 30,
  },
  {
    location_id: 198,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bullsbrook',
    address: '2543 Great Northern Highway, BULLSBROOK WA 6084, Australia',
    latitude: -31.671264,
    longitude: 116.030658,
    radius: 35,
  },
  {
    location_id: 202,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Perth',
    address: '47 Walters Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.953177,
    longitude: 115.861092,
    radius: 15,
  },
  {
    location_id: 204,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wongan Hills',
    address: '5 Fenton Place, WONGAN HILLS WA 6603, Australia',
    latitude: -30.893764,
    longitude: 116.718052,
    radius: 35,
  },
  {
    location_id: 205,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Jurien Bay',
    address: '5 White Street, JURIEN BAY WA 6516, Australia',
    latitude: -30.304929,
    longitude: 115.037849,
    radius: 25,
  },
  {
    location_id: 206,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Kingsley',
    address: '90 Kingsley Drive, KINGSLEY WA 6026, Australia',
    latitude: -31.8075,
    longitude: 115.78926,
    radius: 35,
  },
  {
    location_id: 208,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Lancelin',
    address: '58 Gingin Road, LANCELIN WA 6044, Australia',
    latitude: -31.012824,
    longitude: 115.328722,
    radius: 35,
  },
  {
    location_id: 209,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Bunbury',
    address: 'Brittain Road, BUNBURY WA 6230, Australia',
    latitude: -33.35827,
    longitude: 115.642872,
    radius: 180,
  },
  {
    location_id: 210,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Cannington',
    address: 'Cnr Albany Highway & Station Street, CANNINGTON WA 6107, Australia',
    latitude: -32.021202,
    longitude: 115.942342,
    radius: 100,
  },
  {
    location_id: 211,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Medina',
    address: '23 Pace Road, MEDINA WA 6167, Australia',
    latitude: -32.235103,
    longitude: 115.806673,
    radius: 35,
  },
  {
    location_id: 214,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kununurra',
    address: '37 Messmate Way, KUNUNURRA WA 6743, Australia',
    latitude: -15.7753,
    longitude: 128.738836,
    radius: 40,
  },
  {
    location_id: 216,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Craigie',
    address: '119 Eddystone Avenue, CRAIGIE WA 6025, Australia',
    latitude: -31.783943,
    longitude: 115.767596,
    radius: 40,
  },
  {
    location_id: 217,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Koondoola',
    address: '38 Koondoola Avenue, KOONDOOLA WA 6064, Australia',
    latitude: -31.841742,
    longitude: 115.860176,
    radius: 25,
  },
  {
    location_id: 218,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Ballajura',
    address: '322 Alexander Drive, BALLAJURA WA 6066, Australia',
    latitude: -31.826902,
    longitude: 115.877387,
    radius: 35,
  },
  {
    location_id: 219,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Malaga',
    address: '338 Victoria Road, MALAGA WA 6090, Australia',
    latitude: -31.861936,
    longitude: 115.889859,
    radius: 30,
  },
  {
    location_id: 220,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Mundijong',
    address: '32 Paterson Road, MUNDIJONG WA 6123, Australia',
    latitude: -32.294439,
    longitude: 115.985694,
    radius: 40,
  },
  {
    location_id: 221,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'North Dandalup',
    address: '4224 South Western Highway, NORTH DANDALUP WA 6207, Australia',
    latitude: -32.518612,
    longitude: 115.971086,
    radius: 35,
  },
  {
    location_id: 222,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Balcatta',
    address: '51 Erindale Road, BALCATTA WA 6021, Australia',
    latitude: -31.86597,
    longitude: 115.807981,
    radius: 35,
  },
  {
    location_id: 223,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Byford',
    address: '881 South West Highway, BYFORD WA 6122, Australia',
    latitude: -32.222137,
    longitude: 116.008277,
    radius: 40,
  },
  {
    location_id: 226,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Langford',
    address: '72 Langford Avenue, LANGFORD WA 6147, Australia',
    latitude: -32.043294,
    longitude: 115.941987,
    radius: 30,
  },
  {
    location_id: 227,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Geraldton',
    address: 'Eastward Road, GERALDTON WA 6530, Australia',
    latitude: -28.776812,
    longitude: 114.639131,
    radius: 150,
  },
  {
    location_id: 228,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Donnybrook',
    address: '64 South West Highway, DONNYBROOK WA 6239, Australia',
    latitude: -33.572851,
    longitude: 115.82436,
    radius: 35,
  },
  {
    location_id: 229,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Australind',
    address: '41 Old Coast Road, AUSTRALIND WA 6233, Australia',
    latitude: -33.305066,
    longitude: 115.702229,
    radius: 35,
  },
  {
    location_id: 232,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Halls Head',
    address: '8 Guava Way, HALLS HEAD WA 6210, Australia',
    latitude: -32.550274,
    longitude: 115.702009,
    radius: 40,
  },
  {
    location_id: 233,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Maddington',
    address: '39 Attfield Street, MADDINGTON WA 6109, Australia',
    latitude: -32.050998,
    longitude: 115.976733,
    radius: 30,
  },
  {
    location_id: 234,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Leinster',
    address: 'LOT 402 Mainsbridge Street, LEINSTER WA 6437, Australia',
    latitude: -27.915779,
    longitude: 120.698324,
    radius: 50,
  },
  {
    location_id: 236,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Cervantes',
    address: '1 Cadiz Street, CERVANTES WA 6511, Australia',
    latitude: -30.500925,
    longitude: 115.068505,
    radius: 35,
  },
  {
    location_id: 237,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Williams',
    address: 'LOT 26 Albany Highway, WILLIAMS WA 6391, Australia',
    latitude: -33.028646,
    longitude: 116.879654,
    radius: 35,
  },
  {
    location_id: 238,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Woodvale',
    address: '143 Trappers Drive, WOODVALE WA 6026, Australia',
    latitude: -31.783194,
    longitude: 115.788205,
    radius: 50,
  },
  {
    location_id: 240,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Walpole',
    address: 'South Coast Highway, WALPOLE WA 6398, Australia',
    latitude: -34.975713,
    longitude: 116.727209,
    radius: 35,
  },
  {
    location_id: 244,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Denham',
    address: '43 Knight Terrace, DENHAM WA 6537, Australia',
    latitude: -25.927674,
    longitude: 113.534139,
    radius: 35,
  },
  {
    location_id: 245,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Leeman',
    address: 'Rudduck Street, LEEMAN WA 6514, Australia',
    latitude: -29.944364,
    longitude: 114.98078,
    radius: 45,
  },
  {
    location_id: 246,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Pingelly',
    address: 'Quadrant Street, PINGELLY WA 6308, Australia',
    latitude: -32.532516,
    longitude: 117.083744,
    radius: 30,
  },
  {
    location_id: 247,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Sawyers Valley',
    address: '10860 Great Eastern Highway, SAWYERS VALLEY WA 6074, Australia',
    latitude: -31.903961,
    longitude: 116.204887,
    radius: 35,
  },
  {
    location_id: 248,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Laverton',
    address: '2 Laver Place, LAVERTON WA 6440, Australia',
    latitude: -28.625519,
    longitude: 122.405351,
    radius: 25,
  },
  {
    location_id: 253,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Ravenswood',
    address: 'Lot 65 Lloyd Avenue, RAVENSWOOD WA 6208, Australia',
    latitude: -32.585554,
    longitude: 115.827449,
    radius: 40,
  },
  {
    location_id: 258,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Broome',
    address: '12 Cable Beach Road, BROOME WA 6725, Australia',
    latitude: -17.934803,
    longitude: 122.213587,
    radius: 45,
  },
  {
    location_id: 260,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Scarborough',
    address: '75 Deanmore Road, SCARBOROUGH WA 6019, Australia',
    latitude: -31.888854,
    longitude: 115.767102,
    radius: 25,
  },
  {
    location_id: 261,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Cottesloe',
    address: 'Cnr Marine Pde & Eric Street, COTTESLOE WA 6011, Australia',
    latitude: -31.990012,
    longitude: 115.752866,
    radius: 25,
  },
  {
    location_id: 263,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Canning Vale',
    address: '280 Bannister Road, CANNING VALE WA 6155, Australia',
    latitude: -32.071222,
    longitude: 115.895091,
    radius: 35,
  },
  {
    location_id: 264,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Pemberton',
    address: '66 Brockman Street, PEMBERTON WA 6260, Australia',
    latitude: -34.444386,
    longitude: 116.035917,
    radius: 30,
  },
  {
    location_id: 266,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Waroona',
    address: '16 Fouracre Street, WAROONA WA 6215, Australia',
    latitude: -32.844178,
    longitude: 115.921327,
    radius: 35,
  },
  {
    location_id: 269,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Exmouth',
    address: 'Murat Road, EXMOUTH WA 6707, Australia',
    latitude: -21.928743,
    longitude: 114.125659,
    radius: 60,
  },
  {
    location_id: 270,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Coolgardie',
    address: '73 Bayley Street, COOLGARDIE WA 6429, Australia',
    latitude: -30.955001,
    longitude: 121.16374,
    radius: 35,
  },
  {
    location_id: 272,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Busselton',
    address: '30-38 Marine Terrace, BUSSELTON WA 6280, Australia',
    latitude: -33.646738,
    longitude: 115.345137,
    radius: 45,
  },
  {
    location_id: 273,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kardinya',
    address: '17 South Street, KARDINYA WA 6163, Australia',
    latitude: -32.068088,
    longitude: 115.818244,
    radius: 30,
  },
  {
    location_id: 276,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Gosnells',
    address: '70 Blanche Street, GOSNELLS WA 6110, Australia',
    latitude: -32.068595,
    longitude: 115.982616,
    radius: 30,
  },
  {
    location_id: 277,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Beldon',
    address: 'Cnr Marmion Ave & Gunter Grove, BELDON WA 6027, Australia',
    latitude: -31.777024,
    longitude: 115.755592,
    radius: 20,
  },
  {
    location_id: 278,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Two Rocks',
    address: '50 Enterprise Avenue, TWO ROCKS WA 6037, Australia',
    latitude: -31.496129,
    longitude: 115.584481,
    radius: 30,
  },
  {
    location_id: 281,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Joondalup',
    address: 'Unit Shop GD T142 Collier Pass, JOONDALUP WA 6027, Australia',
    latitude: -31.744327,
    longitude: 115.764956,
    radius: 15,
  },
  {
    location_id: 285,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Internet Betting',
    address: 'OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 286,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Yanchep',
    address: 'Yanchep National Park, YANCHEP WA 6035, Australia',
    latitude: -31.544313,
    longitude: 115.683131,
    radius: 40,
  },
  {
    location_id: 287,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Albany',
    address: '169 Lancaster Road, ALBANY WA 6330, Australia',
    latitude: -34.986016,
    longitude: 117.832628,
    radius: 130,
  },
  {
    location_id: 288,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Port Denison',
    address: '60 Point Leander Drive, PORT DENISON WA 6525, Australia',
    latitude: -29.274364,
    longitude: 114.921228,
    radius: 30,
  },
  {
    location_id: 290,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Bunbury',
    address: 'Hands Avenue, BUNBURY WA 6230, Australia',
    latitude: -33.355669,
    longitude: 115.65501,
    radius: 180,
  },
  {
    location_id: 291,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Carine',
    address: '493 Beach Road, DUNCRAIG WA 6023, Australia',
    latitude: -31.845221,
    longitude: 115.787455,
    radius: 40,
  },
  {
    location_id: 293,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Corrigin',
    address: '17 Walton Street, CORRIGIN WA 6375, Australia',
    latitude: -32.330577,
    longitude: 117.873809,
    radius: 30,
  },
  {
    location_id: 294,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Port Kennedy',
    address: '379 Warnbro Sound Avenue, PORT KENNEDY WA 6172, Australia',
    latitude: -32.366741,
    longitude: 115.7553,
    radius: 35,
  },
  {
    location_id: 295,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Carlisle',
    address: '174 Rutland Avenue, CARLISLE WA 6101, Australia',
    latitude: -31.97972,
    longitude: 115.910842,
    radius: 40,
  },
  {
    location_id: 296,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Tom Price',
    address: 'Central Road, TOM PRICE WA 6751, Australia',
    latitude: -22.694842,
    longitude: 117.79536,
    radius: 30,
  },
  {
    location_id: 297,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Casuarina',
    address: '34 Marri Park Drive, CASUARINA WA 6167, Australia',
    latitude: -32.23142,
    longitude: 115.870051,
    radius: 40,
  },
  {
    location_id: 299,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'South Lake',
    address: 'Unit Shop 3 Lot 101 North Lake Road, SOUTH LAKE WA 6164, Australia',
    latitude: -32.106615,
    longitude: 115.827227,
    radius: 15,
  },
  {
    location_id: 300,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Broome',
    address: 'Gantheaume Point Road, BROOME WA 6725, Australia',
    latitude: -17.975302,
    longitude: 122.183743,
    radius: 150,
  },
  {
    location_id: 302,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bindoon',
    address: '6626 Great Northern Highway, BINDOON WA 6502, Australia',
    latitude: -31.351161,
    longitude: 116.114087,
    radius: 25,
  },
  {
    location_id: 305,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Boddington',
    address: '40-50 Bannister Road, BODDINGTON WA 6390, Australia',
    latitude: -32.802939,
    longitude: 116.473868,
    radius: 25,
  },
  {
    location_id: 308,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Dalwallinu',
    address: '19 Johnston Street, DALWALLINU WA 6609, Australia',
    latitude: -30.277854,
    longitude: 116.662096,
    radius: 25,
  },
  {
    location_id: 309,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Karratha',
    address: '27 Bond Place, KARRATHA WA 6714, Australia',
    latitude: -20.739019,
    longitude: 116.829097,
    radius: 30,
  },
  {
    location_id: 312,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'South Yunderup',
    address: '146 South Yunderup Road, SOUTH YUNDERUP WA 6208, Australia',
    latitude: -32.58516,
    longitude: 115.794364,
    radius: 25,
  },
  {
    location_id: 314,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Port Hedland',
    address: '944 Great Northern Highway, PORT HEDLAND WA 6721, Australia',
    latitude: -20.376714,
    longitude: 118.635006,
    radius: 30,
  },
  {
    location_id: 315,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Marvel Loch',
    address: '17 Lennenberg Street, MARVEL LOCH WA 6426, Australia',
    latitude: -31.46711,
    longitude: 119.487,
    radius: 40,
  },
  {
    location_id: 316,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Belmont',
    address: '44 Belvidere Street, BELMONT WA 6104, Australia',
    latitude: -31.946898,
    longitude: 115.939922,
    radius: 25,
  },
  {
    location_id: 317,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Madeley',
    address: 'Shop 2 Cnr Hepburn Ave & Wanneroo Road, MADELEY WA 6065, Australia',
    latitude: -31.818556,
    longitude: 115.82154,
    radius: 25,
  },
  {
    location_id: 318,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Thornlie',
    address: 'Unit Shop 10 101 Forest Lakes Drive, THORNLIE WA 6108, Australia',
    latitude: -32.069147,
    longitude: 115.951778,
    radius: 30,
  },
  {
    location_id: 321,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Mindarie',
    address: 'Unit 1 4 Bergen Way, MINDARIE WA 6030, Australia',
    latitude: -31.677644,
    longitude: 115.711994,
    radius: 15,
  },
  {
    location_id: 325,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bouvard',
    address: '21-23 Park Ridge Drive, BOUVARD WA 6211, Australia',
    latitude: -32.668133,
    longitude: 115.649839,
    radius: 25,
  },
  {
    location_id: 331,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kalgoorlie',
    address: '164 Piccadilly Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.744143,
    longitude: 121.4645,
    radius: 25,
  },
  {
    location_id: 332,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Boulder',
    address: '140 Burt Street, BOULDER WA 6432, Australia',
    latitude: -30.782063,
    longitude: 121.484146,
    radius: 20,
  },
  {
    location_id: 333,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kalgoorlie',
    address: '75 Cheetham Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.753441,
    longitude: 121.472333,
    radius: 20,
  },
  {
    location_id: 338,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Madora',
    address: '1 Madora Beach Road, MADORA BAY WA 6210, Australia',
    latitude: -32.46973,
    longitude: 115.74802,
    radius: 20,
  },
  {
    location_id: 339,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Yangebup',
    address: '40 Birchley Road, YANGEBUP WA 6164, Australia',
    latitude: -32.10054,
    longitude: 115.783791,
    radius: 25,
  },
  {
    location_id: 345,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Redcliffe',
    address: '431 Great Eastern Highway, REDCLIFFE WA 6104, Australia',
    latitude: -31.930148,
    longitude: 115.94548,
    radius: 25,
  },
  {
    location_id: 346,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Gosnells',
    address: '292 Corfield Street, GOSNELLS WA 6110, Australia',
    latitude: -32.08941,
    longitude: 115.999467,
    radius: 25,
  },
  {
    location_id: 347,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Ravensthorpe',
    address: '28 Morgan Street, RAVENSTHORPE WA 6346, Australia',
    latitude: -33.581916,
    longitude: 120.046744,
    radius: 25,
  },
  {
    location_id: 349,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wattleup',
    address: '1048 Rockingham Road, WATTLEUP WA 6166, Australia',
    latitude: -32.177823,
    longitude: 115.794491,
    radius: 30,
  },
  {
    location_id: 350,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Osborne Park',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 351,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Boyanup',
    address: '104 Bridge Street, BOYANUP WA 6237, Australia',
    latitude: -33.48088,
    longitude: 115.731547,
    radius: 45,
  },
  {
    location_id: 353,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Exmouth',
    address: '26 Payne Street, EXMOUTH WA 6707, Australia',
    latitude: -21.930337,
    longitude: 114.125116,
    radius: 25,
  },
  {
    location_id: 354,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Onslow',
    address: '22 Second Avenue, ONSLOW WA 6710, Australia',
    latitude: -21.63991,
    longitude: 115.11504,
    radius: 20,
  },
  {
    location_id: 355,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Tuart Hill',
    address: '112 Wanneroo Road, TUART HILL WA 6060, Australia',
    latitude: -31.900778,
    longitude: 115.842728,
    radius: 25,
  },
  {
    location_id: 356,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Rockingham',
    address: '1 Chalgrove Avenue, ROCKINGHAM WA 6168, Australia',
    latitude: -32.289191,
    longitude: 115.740881,
    radius: 25,
  },
  {
    location_id: 357,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Dunsborough',
    address: 'Naturaliste Terrace, DUNSBOROUGH WA 6281, Australia',
    latitude: -33.616961,
    longitude: 115.106743,
    radius: 35,
  },
  {
    location_id: 358,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Karridale',
    address: '12440 Bussell Highway, KARRIDALE WA 6288, Australia',
    latitude: -34.202162,
    longitude: 115.098892,
    radius: 30,
  },
  {
    location_id: 359,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'South Lake',
    address: '52 Berrigan Drive, SOUTH LAKE WA 6164, Australia',
    latitude: -32.110934,
    longitude: 115.839892,
    radius: 25,
  },
  {
    location_id: 360,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Esperance',
    address: 'Lot 202 Fisheries Road, ESPERANCE WA 6450, Australia',
    latitude: -33.818001,
    longitude: 121.927638,
    radius: 160,
  },
  {
    location_id: 362,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'East Perth',
    address: '248 Hay Street, EAST PERTH WA 6004, Australia',
    latitude: -31.957999,
    longitude: 115.871268,
    radius: 20,
  },
  {
    location_id: 364,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Account Sales Centre (Call Centre)',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 365,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Carnarvon',
    address: 'Massey Bay Road, CARNARVON WA 6701, Australia',
    latitude: -24.906855,
    longitude: 113.674264,
    radius: 100,
  },
  {
    location_id: 369,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Newman',
    address: '1401 Newman Drive, NEWMAN WA 6753, Australia',
    latitude: -23.35776,
    longitude: 119.728382,
    radius: 25,
  },
  {
    location_id: 375,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Beaconsfield',
    address: '73 Wray Avenue, FREMANTLE WA 6160, Australia',
    latitude: -32.062222,
    longitude: 115.757326,
    radius: 30,
  },
  {
    location_id: 384,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Doubleview',
    address: '17 Shearn Crescent, DOUBLEVIEW WA 6018, Australia',
    latitude: -31.901536,
    longitude: 115.778747,
    radius: 40,
  },
  {
    location_id: 385,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Merriwa',
    address: '36 Baltimore Parade, MERRIWA WA 6030, Australia',
    latitude: -31.670813,
    longitude: 115.715836,
    radius: 35,
  },
  {
    location_id: 389,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Collie',
    address: 'McVee Road, COLLIE WA 6225, Australia',
    latitude: -33.372885,
    longitude: 116.169802,
    radius: 120,
  },
  {
    location_id: 390,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Junction',
    address: 'Mullewa Road, GASCOYNE JUNCTION WA 6705, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 392,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'South Hedland',
    address: 'Throssell Road, SOUTH HEDLAND WA 6722, Australia',
    latitude: -20.408904,
    longitude: 118.600073,
    radius: 40,
  },
  {
    location_id: 393,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bicton',
    address: '326 Canning Highway, BICTON WA 6157, Australia',
    latitude: -32.035903,
    longitude: 115.784856,
    radius: 30,
  },
  {
    location_id: 394,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wagin',
    address: 'Tavistock Street, WAGIN WA 6315, Australia',
    latitude: -33.309615,
    longitude: 117.344708,
    radius: 25,
  },
  {
    location_id: 396,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bassendean',
    address: '77 Walter Road, BASSENDEAN WA 6054, Australia',
    latitude: -31.895116,
    longitude: 115.944555,
    radius: 25,
  },
  {
    location_id: 397,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'York',
    address: 'Spencer Brook Road, YORK WA 6302, Australia',
    latitude: -31.861345,
    longitude: 116.773219,
    radius: 100,
  },
  {
    location_id: 401,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Belmont',
    address: 'Goodwood Parade, RIVERVALE WA 6103, Australia',
    latitude: -31.947082,
    longitude: 115.892007,
    radius: 120,
  },
  {
    location_id: 402,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Nannup',
    address: '12 Warren Road, NANNUP WA 6275, Australia',
    latitude: -33.977193,
    longitude: 115.764442,
    radius: 25,
  },
  {
    location_id: 408,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Dianella',
    address: '302 The Strand, DIANELLA WA 6059, Australia',
    latitude: -31.897832,
    longitude: 115.880747,
    radius: 30,
  },
  {
    location_id: 411,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'South Fremantle',
    address: '396 South Terrace, SOUTH FREMANTLE WA 6162, Australia',
    latitude: -32.072838,
    longitude: 115.75323,
    radius: 25,
  },
  {
    location_id: 412,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Derby',
    address: 'Clarendon Street, DERBY WA 6728, Australia',
    latitude: -17.303602,
    longitude: 123.626477,
    radius: 40,
  },
  {
    location_id: 413,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Ascot',
    address: '70 Grandstand Road, ASCOT WA 6104, Australia',
    latitude: -31.937422,
    longitude: 115.923079,
    radius: 220,
  },
  {
    location_id: 414,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Neo Exotica - Ascot',
    address: 'Grandstand Road, ASCOT WA 6104, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 0,
  },
  {
    location_id: 418,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Pinjarra',
    address: '1 Williams Road, PINJARRA WA 6208, Australia',
    latitude: -32.627664,
    longitude: 115.878309,
    radius: 30,
  },
  {
    location_id: 419,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Albany',
    address: '244 York Street, ALBANY WA 6330, Australia',
    latitude: -35.022775,
    longitude: 117.883639,
    radius: 25,
  },
  {
    location_id: 420,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Esperance',
    address: 'The Esplanade, ESPERANCE WA 6450, Australia',
    latitude: -33.861517,
    longitude: 121.89347,
    radius: 25,
  },
  {
    location_id: 422,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bunbury',
    address: '36 Victoria Street, BUNBURY WA 6230, Australia',
    latitude: -33.322778,
    longitude: 115.637169,
    radius: 30,
  },
  {
    location_id: 423,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Credit Card Deposits',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 426,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'East Perth',
    address: 'Nelson Crescent, EAST PERTH WA 6004, Australia',
    latitude: -31.956992,
    longitude: 115.880637,
    radius: 120,
  },
  {
    location_id: 428,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Cooloongup',
    address: 'LOT 504 Ennis Avenue, COOLOONGUP WA 6168, Australia',
    latitude: -32.296056,
    longitude: 115.763303,
    radius: 40,
  },
  {
    location_id: 429,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Fairplay Print',
    address: '46 Furniss Road, LANDSDALE WA 6065, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 430,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Eaton',
    address: 'Pratt Road, EATON WA 6232, Australia',
    latitude: -33.313512,
    longitude: 115.705708,
    radius: 30,
  },
  {
    location_id: 431,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Merredin',
    address: '58 Bates Street, MERREDIN WA 6415, Australia',
    latitude: -31.477303,
    longitude: 118.278139,
    radius: 25,
  },
  {
    location_id: 433,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Gidgegannup',
    address: '2672 Toodyay Road, GIDGEGANNUP WA 6083, Australia',
    latitude: -31.770939,
    longitude: 116.240684,
    radius: 25,
  },
  {
    location_id: 439,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Maylands',
    address: 'Unit Shop 1 32 East Street, MAYLANDS WA 6051, Australia',
    latitude: -31.934136,
    longitude: 115.894915,
    radius: 25,
  },
  {
    location_id: 440,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Guildford',
    address: '50 East Street, GUILDFORD WA 6055, Australia',
    latitude: -31.897488,
    longitude: 115.982229,
    radius: 25,
  },
  {
    location_id: 443,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'North Perth',
    address: '509 Charles Street, NORTH PERTH WA 6006, Australia',
    latitude: -31.916807,
    longitude: 115.847921,
    radius: 40,
  },
  {
    location_id: 444,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Melville',
    address: '592 Canning Highway, ALFRED COVE WA 6154, Australia',
    latitude: -32.029781,
    longitude: 115.817163,
    radius: 25,
  },
  {
    location_id: 445,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bunbury',
    address: '41 Stephens Street, BUNBURY WA 6230, Australia',
    latitude: -33.326292,
    longitude: 115.638337,
    radius: 25,
  },
  {
    location_id: 449,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Katanning',
    address: '111 Clive Street, KATANNING WA 6317, Australia',
    latitude: -33.689898,
    longitude: 117.555789,
    radius: 25,
  },
  {
    location_id: 450,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Mandurah',
    address: 'Unit Peel S/Centre 40-44 Pinjarra Road, MANDURAH WA 6210, Australia',
    latitude: -32.53422,
    longitude: 115.722245,
    radius: 20,
  },
  {
    location_id: 451,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Internet Betting',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 454,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Southern River',
    address: '7 Holmes Street, SOUTHERN RIVER WA 6110, Australia',
    latitude: -32.090478,
    longitude: 115.943597,
    radius: 25,
  },
  {
    location_id: 455,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Canning Vale',
    address: '30-34 Ranford Road, CANNING VALE WA 6155, Australia',
    latitude: -32.087501,
    longitude: 115.917563,
    radius: 25,
  },
  {
    location_id: 456,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kalgoorlie',
    address: '80 Egan Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.746297,
    longitude: 121.475409,
    radius: 25,
  },
  {
    location_id: 457,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Eaton',
    address: '1 Albatross Crescent, EATON WA 6232, Australia',
    latitude: -33.31995,
    longitude: 115.715152,
    radius: 30,
  },
  {
    location_id: 458,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Northcliffe',
    address: '17-19 Wheatley Coast Road, NORTHCLIFFE WA 6262, Australia',
    latitude: -34.631001,
    longitude: 116.123729,
    radius: 25,
  },
  {
    location_id: 464,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Success',
    address: '816 Beeliar Drive, SUCCESS WA 6164, Australia',
    latitude: -32.131688,
    longitude: 115.854731,
    radius: 40,
  },
  {
    location_id: 466,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Kalgoorlie',
    address: 'Meldrum Avenue, KALGOORLIE WA 6430, Australia',
    latitude: -30.7609,
    longitude: 121.464985,
    radius: 120,
  },
  {
    location_id: 467,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Derby',
    address: '98 Loch Street, DERBY WA 6728, Australia',
    latitude: -17.308605,
    longitude: 123.638181,
    radius: 35,
  },
  {
    location_id: 470,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Thornlie',
    address: '336 Spencer Road, THORNLIE WA 6108, Australia',
    latitude: -32.057367,
    longitude: 115.963842,
    radius: 40,
  },
  {
    location_id: 472,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Morawa',
    address: 'Solomon Terrace, MORAWA WA 6623, Australia',
    latitude: -29.210387,
    longitude: 116.011033,
    radius: 25,
  },
  {
    location_id: 477,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Piara Waters',
    address: '625 Warton Road, PIARA WATERS WA 6112, Australia',
    latitude: -32.115817,
    longitude: 115.916067,
    radius: 25,
  },
  {
    location_id: 481,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Mandurah',
    address: '89 Allnutt Street, MANDURAH WA 6210, Australia',
    latitude: -32.528042,
    longitude: 115.741269,
    radius: 50,
  },
  {
    location_id: 482,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Dudley Park',
    address: '28 Eden Street, DUDLEY PARK WA 6210, Australia',
    latitude: -32.539546,
    longitude: 115.729103,
    radius: 35,
  },
  {
    location_id: 484,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wanneroo',
    address: '18 Dundebar Road, WANNEROO WA 6065, Australia',
    latitude: -31.751169,
    longitude: 115.804342,
    radius: 40,
  },
  {
    location_id: 485,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wokalup',
    address: '67 South West Highway, WOKALUP WA 6221, Australia',
    latitude: -33.111862,
    longitude: 115.880715,
    radius: 40,
  },
  {
    location_id: 486,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Canning Vale',
    address: '507 Nicholson Road, CANNING VALE WA 6155, Australia',
    latitude: -32.066739,
    longitude: 115.932124,
    radius: 30,
  },
  {
    location_id: 487,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Baldivis',
    address: '13 Settlers Avenue, BALDIVIS WA 6171, Australia',
    latitude: -32.332855,
    longitude: 115.813655,
    radius: 30,
  },
  {
    location_id: 492,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Belmont',
    address: '400 Abernethy Road, CLOVERDALE WA 6105, Australia',
    latitude: -31.969677,
    longitude: 115.943004,
    radius: 40,
  },
  {
    location_id: 502,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Mosman Park',
    address: '39 Bay View Terrace, MOSMAN PARK WA 6012, Australia',
    latitude: -32.008931,
    longitude: 115.769591,
    radius: 25,
  },
  {
    location_id: 503,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Northam',
    address: '75 Fitzgerald Street, NORTHAM WA 6401, Australia',
    latitude: -31.660103,
    longitude: 116.663454,
    radius: 25,
  },
  {
    location_id: 505,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Gingin',
    address: '5 Jones Street, GINGIN WA 6503, Australia',
    latitude: -31.350861,
    longitude: 115.90411,
    radius: 25,
  },
  {
    location_id: 507,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Morley/Noranda',
    address: '85 McGilvray Avenue, NORANDA WA 6062, Australia',
    latitude: -31.878182,
    longitude: 115.894339,
    radius: 40,
  },
  {
    location_id: 509,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'High Wycombe',
    address: 'Unit Unit 11 530 Kalamunda Road, HIGH WYCOMBE WA 6057, Australia',
    latitude: -31.935562,
    longitude: 116.005116,
    radius: 15,
  },
  {
    location_id: 513,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Newman',
    address: 'LOT 1982 Newman Drive, NEWMAN WA 6753, Australia',
    latitude: -23.357477,
    longitude: 119.731646,
    radius: 25,
  },
  {
    location_id: 515,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Tuart Hill',
    address: '31 Park Street, TUART HILL WA 6060, Australia',
    latitude: -31.894261,
    longitude: 115.83181,
    radius: 35,
  },
  {
    location_id: 516,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Innaloo',
    address: '75 Birdwood Street, INNALOO WA 6018, Australia',
    latitude: -31.886969,
    longitude: 115.793637,
    radius: 35,
  },
  {
    location_id: 518,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Busselton',
    address: '117 Queen Street, BUSSELTON WA 6280, Australia',
    latitude: -33.651663,
    longitude: 115.345209,
    radius: 25,
  },
  {
    location_id: 521,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'High Wycombe',
    address: '530 Kalamunda Road, HIGH WYCOMBE WA 6057, Australia',
    latitude: -31.93528,
    longitude: 116.005799,
    radius: 25,
  },
  {
    location_id: 522,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Camillo',
    address: '127 Westfield Road, CAMILLO WA 6111, Australia',
    latitude: -32.118877,
    longitude: 116.002025,
    radius: 25,
  },
  {
    location_id: 524,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Pinjarra',
    address: 'Lot 210 Race Course Road, PINJARRA WA 6208, Australia',
    latitude: -32.631585,
    longitude: 115.88513,
    radius: 120,
  },
  {
    location_id: 525,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Meekatharra',
    address: '53 Main Street, MEEKATHARRA WA 6642, Australia',
    latitude: -26.59084,
    longitude: 118.49697,
    radius: 25,
  },
  {
    location_id: 527,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Derby',
    address: '999 Ashley Street, DERBY WA 6728, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 532,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Ellenbrook',
    address: '11 Main Street, ELLENBROOK WA 6069, Australia',
    latitude: -31.781885,
    longitude: 115.967387,
    radius: 40,
  },
  {
    location_id: 533,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Karratha',
    address: 'Searipple Road, KARRATHA WA 6714, Australia',
    latitude: -20.727032,
    longitude: 116.862356,
    radius: 30,
  },
  {
    location_id: 534,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Waroona',
    address: '8229 South Western Highway, WAROONA WA 6215, Australia',
    latitude: -32.835897,
    longitude: -32.835897,
    radius: 45,
  },
  {
    location_id: 535,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Inglewood',
    address: '981 Beaufort Street, INGLEWOOD WA 6052, Australia',
    latitude: -31.917368,
    longitude: 115.8905,
    radius: 40,
  },
  {
    location_id: 536,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'BPAY Deposits',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 537,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Darch',
    address: '213 Kingsway, DARCH WA 6065, Australia',
    latitude: -31.812514,
    longitude: 115.843529,
    radius: 40,
  },
  {
    location_id: 538,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Mobile Wagering',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 540,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Interactive TV (ITV)',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 541,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'North Beach',
    address: '7 Kitchener Street, NORTH BEACH WA 6020, Australia',
    latitude: -31.86447,
    longitude: 115.7585,
    radius: 30,
  },
  {
    location_id: 542,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Expert Bet Services',
    address: '14 Hasler Street, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 543,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'TABOzBet Services',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 544,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'OZBet Page',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 545,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Kellerberrin',
    address: 'Connelly Street, KELLERBERRIN WA 6410, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 546,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Mount Barker',
    address: 'McDonald Avenue, MOUNT BARKER WA 6324, Australia',
    latitude: -34.62061,
    longitude: 117.65418,
    radius: 100,
  },
  {
    location_id: 548,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wanneroo',
    address: 'Crisafulli Avenue, WANNEROO WA 6065, Australia',
    latitude: -31.755513,
    longitude: 115.801954,
    radius: 35,
  },
  {
    location_id: 552,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Quinns Rocks',
    address: '17 Tapping Way, QUINNS ROCKS WA 6030, Australia',
    latitude: -31.670962,
    longitude: 115.703307,
    radius: 45,
  },
  {
    location_id: 553,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Nowergup',
    address: '2310 Wanneroo Road, NOWERGUP WA 6032, Australia',
    latitude: -31.649058,
    longitude: 115.73492,
    radius: 40,
  },
  {
    location_id: 554,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Thornlie',
    address: '50-60 Thornlie Avenue, THORNLIE WA 6108, Australia',
    latitude: -32.049872,
    longitude: 115.965578,
    radius: 35,
  },
  {
    location_id: 555,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'High Wycombe',
    address: '107 Dundas Road, HIGH WYCOMBE WA 6057, Australia',
    latitude: -31.94024,
    longitude: 115.99131,
    radius: 30,
  },
  {
    location_id: 556,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Pinjarra',
    address: '7 Greenlands Road, PINJARRA WA 6208, Australia',
    latitude: -32.642627,
    longitude: 115.867782,
    radius: 100,
  },
  {
    location_id: 557,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Pinjarra',
    address: '7 PACEWAY COURT, PINJARRA WA 6208, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 561,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Belmont',
    address: '174 Wright Street, BELMONT WA 6104, Australia',
    latitude: -31.966613,
    longitude: 115.931645,
    radius: 25,
  },
  {
    location_id: 562,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bunbury',
    address: 'Cnr Spencer Street & Forrest Avenue, BUNBURY WA 6230, Australia',
    latitude: -33.336123,
    longitude: 115.640711,
    radius: 30,
  },
  {
    location_id: 563,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Thornlie',
    address: '119 Murdoch Road, THORNLIE WA 6108, Australia',
    latitude: -32.069147,
    longitude: 115.951732,
    radius: 30,
  },
  {
    location_id: 565,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Karratha',
    address: 'Lot 4227 Tambrey Drive, KARRATHA WA 6714, Australia',
    latitude: -20.742795,
    longitude: 116.80397,
    radius: 50,
  },
  {
    location_id: 569,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Currambine',
    address: 'Unit FS002 1244 Marmion Avenue, CURRAMBINE WA 6028, Australia',
    latitude: -31.740913,
    longitude: 115.738796,
    radius: 25,
  },
  {
    location_id: 571,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bentley',
    address: '1120-1124 Albany Highway, BENTLEY WA 6102, Australia',
    latitude: -31.99982,
    longitude: 115.918203,
    radius: 40,
  },
  {
    location_id: 572,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'West Perth',
    address: '1292 Hay Street, WEST PERTH WA 6005, Australia',
    latitude: -31.947681,
    longitude: 115.83981,
    radius: 25,
  },
  {
    location_id: 577,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Marmion',
    address: 'West Coast Drive, MARMION WA 6020, Australia',
    latitude: -31.838468,
    longitude: 115.749888,
    radius: 30,
  },
  {
    location_id: 578,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Hamilton Hill',
    address: '330 Carrington Street, HAMILTON HILL WA 6163, Australia',
    latitude: -32.075369,
    longitude: 115.780559,
    radius: 25,
  },
  {
    location_id: 579,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Willetton',
    address: 'Cnr Burrendah Blvd & Pinetree Gully Road, WILLETTON WA 6155, Australia',
    latitude: -32.057975,
    longitude: 115.881653,
    radius: 25,
  },
  {
    location_id: 581,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Cervantes',
    address: 'Aragon Street, CERVANTES WA 6511, Australia',
    latitude: -30.499444,
    longitude: 115.070496,
    radius: 25,
  },
  {
    location_id: 583,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Albany',
    address: '261 Roberts Road, ALBANY WA 6330, Australia',
    latitude: -35.034949,
    longitude: 117.815266,
    radius: 100,
  },
  {
    location_id: 584,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Narrogin',
    address: '50 Clayton Street, NARROGIN WA 6312, Australia',
    latitude: -32.930225,
    longitude: 117.172992,
    radius: 100,
  },
  {
    location_id: 587,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Hopetoun',
    address: '279 Hopetoun-Ravensthorpe Road, HOPETOUN WA 6348, Australia',
    latitude: -33.918062,
    longitude: 120.136675,
    radius: 30,
  },
  {
    location_id: 588,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kwinana',
    address: '1 Chisham Avenue, KWINANA TOWN CENTRE WA 6167, Australia',
    latitude: -32.243738,
    longitude: 115.814671,
    radius: 30,
  },
  {
    location_id: 589,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Yallingup',
    address: '18 Yallingup Beach Road, YALLINGUP WA 6282, Australia',
    latitude: -33.645227,
    longitude: 115.031287,
    radius: 40,
  },
  {
    location_id: 590,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kellerberrin',
    address: 'Unit Lot 260 Connelly Street, KELLERBERRIN WA 6410, Australia',
    latitude: -31.627902,
    longitude: 117.715996,
    radius: 25,
  },
  {
    location_id: 592,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Dongara',
    address: 'Brennand Road, DONGARA WA 6525, Australia',
    latitude: -29.243912,
    longitude: 114.925177,
    radius: 100,
  },
  {
    location_id: 593,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Coolgardie',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 594,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'York ',
    address: 'Spencer Brook Road, YORK WA 6302, Australia',
    latitude: -31.861355,
    longitude: 116.773171,
    radius: 100,
  },
  {
    location_id: 597,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Kununurra',
    address: 'Racecourse Road, KUNUNURRA WA 6743, Australia',
    latitude: -15.803778,
    longitude: 128.749696,
    radius: 100,
  },
  {
    location_id: 603,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Mingenew',
    address: 'Via Midlands Road, MINGENEW WA 6522, Australia',
    latitude: -29.199658,
    longitude: 115.447749,
    radius: 100,
  },
  {
    location_id: 604,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Moora',
    address: '62 Padbury Street, MOORA WA 6510, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 606,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Newman',
    address: 'Great Northern Highway, NEWMAN WA 6753, Australia',
    latitude: -23.344724,
    longitude: 119.746881,
    radius: 100,
  },
  {
    location_id: 607,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Northam',
    address: '175 Yilgarn Street, NORTHAM WA 6401, Australia',
    latitude: -31.63994,
    longitude: 116.69995,
    radius: 100,
  },
  {
    location_id: 610,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Port Hedland',
    address: 'McGregor Road, PORT HEDLAND WA 6721, Australia',
    latitude: -20.309577,
    longitude: 118.612363,
    radius: 100,
  },
  {
    location_id: 611,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Roebourne',
    address: 'North West Coastal Highway, KARRATHA WA 6714, Australia',
    latitude: -20.787933,
    longitude: 117.15849,
    radius: 100,
  },
  {
    location_id: 612,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Williams',
    address: '35 Richmond Street, WILLIAMS WA 6391, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 613,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Wagin',
    address: 'Ballagin Street, WAGIN WA 6315, Australia',
    latitude: -33.306131,
    longitude: 117.336944,
    radius: 100,
  },
  {
    location_id: 616,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Narrogin',
    address: '50 Clayton Road, NARROGIN WA 6312, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 617,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Northam',
    address: 'Clark Street, NORTHAM WA 6401, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 618,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Northam',
    address: 'Clark Street, NORTHAM WA 6401, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 100,
  },
  {
    location_id: 620,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Toodyay',
    address: 'Racecourse Road, TOODYAY WA 6566, Australia',
    latitude: -31.57304,
    longitude: 116.46357,
    radius: 100,
  },
  {
    location_id: 621,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kalgoorlie',
    address: '497 Hannan Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.754828,
    longitude: 121.46481,
    radius: 25,
  },
  {
    location_id: 623,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Carramar',
    address: '2 Innesvale Way, CARRAMAR WA 6031, Australia',
    latitude: -31.712155,
    longitude: 115.790041,
    radius: 30,
  },
  {
    location_id: 624,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Ashby',
    address: '131 Pinjar Road, ASHBY WA 6065, Australia',
    latitude: -31.731004,
    longitude: 115.804441,
    radius: 50,
  },
  {
    location_id: 625,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Girrawheen',
    address: '61 Templeton Crescent, GIRRAWHEEN WA 6064, Australia',
    latitude: -31.836967,
    longitude: 115.830186,
    radius: 25,
  },
  {
    location_id: 626,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Mt Barker',
    address: '9 Lowood Road, MOUNT BARKER WA 6324, Australia',
    latitude: -34.625439,
    longitude: 117.661311,
    radius: 30,
  },
  {
    location_id: 627,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Balcatta',
    address: '501 Wanneroo Road, BALCATTA WA 6021, Australia',
    latitude: -31.861764,
    longitude: 115.826395,
    radius: 25,
  },
  {
    location_id: 630,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Non Prod: Osborne Park',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  {
    location_id: 631,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Subiaco',
    address: '328 Barker Road, SUBIACO WA 6008, Australia',
    latitude: -31.948579,
    longitude: 115.823362,
    radius: 25,
  },
  {
    location_id: 632,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Mandurah',
    address: '1 Marco Polo Drive, MANDURAH WA 6210, Australia',
    latitude: -32.528357,
    longitude: 115.717342,
    radius: 50,
  },
  {
    location_id: 633,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Rockingham',
    address: 'cnr Siren Street and Contest Parade, ROCKINGHAM WA 6168, Australia',
    latitude: -32.288421,
    longitude: 115.748326,
    radius: 25,
  },
  {
    location_id: 635,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wickham',
    address: 'Unit Lot 780 Carse Street, WICKHAM WA 6720, Australia',
    latitude: -20.677558,
    longitude: 117.14062,
    radius: 25,
  },
  {
    location_id: 636,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Morley',
    address: '250 Walter Road, MORLEY WA 6062, Australia',
    latitude: -31.895463,
    longitude: 115.896878,
    radius: 25,
  },
  {
    location_id: 637,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Forrestfield',
    address: '64 Hale Road, FORRESTFIELD WA 6058, Australia',
    latitude: -31.988475,
    longitude: 116.009463,
    radius: 40,
  },
  {
    location_id: 638,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Fremantle',
    address: '23 William Street, FREMANTLE WA 6160, Australia',
    latitude: -32.054846,
    longitude: 115.74792,
    radius: 30,
  },
  {
    location_id: 639,
    venue_id: 'TAB',
    opening_type: 'On Course',
    location_name: 'Esperance Bay Turf Club',
    address: 'Unit Lot 202 Fisheries Road, ESPERANCE WA 6450, Australia',
    latitude: -33.81809,
    longitude: 121.92787,
    radius: 160,
  },
  {
    location_id: 641,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Victoria Park',
    address: '314 Albany Highway, VICTORIA PARK WA 6100, Australia',
    latitude: -31.972485,
    longitude: 115.896182,
    radius: 30,
  },
  {
    location_id: 643,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Armadale',
    address: '131 Eighth Street, ARMADALE WA 6112, Australia',
    latitude: -32.148003,
    longitude: 115.984976,
    radius: 40,
  },
  {
    location_id: 644,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Inglewood',
    address: '803 Beaufort Street, INGLEWOOD WA 6052, Australia',
    latitude: -31.925096,
    longitude: 115.880992,
    radius: 25,
  },
  {
    location_id: 645,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Ballajura',
    address: 'Unit Shop 39-44 1 Kingfisher Avenue, BALLAJURA WA 6066, Australia',
    latitude: -31.83934,
    longitude: 115.8959,
    radius: 25,
  },
  {
    location_id: 646,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Armadale',
    address: '229 Jull Street, ARMADALE WA 6112, Australia',
    latitude: -32.15259,
    longitude: 116.01392,
    radius: 25,
  },
  {
    location_id: 649,
    venue_id: 'TAB',
    opening_type: 'Full Time',
    location_name: 'Burswood (Stadium)',
    address: '333 Victoria Park Drive, BURSWOOD WA 6100, Australia',
    latitude: -31.95162,
    longitude: 115.8878,
    radius: 25,
  },
  {
    location_id: 650,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Mandurah',
    address: 'Unit Shop R-008 330 Pinjarra Road, MANDURAH WA 6210, Australia',
    latitude: -32.53615,
    longitude: 115.74151,
    radius: 25,
  },
  {
    location_id: 651,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Burswood',
    address: 'Victoria Park Drive, BURSWOOD WA 6100, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 200,
  },
  {
    location_id: 660,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Belmont',
    address: 'Unit Belmont Forum Shop FB001 Belmont Avenue, CLOVERDALE WA 6105, Australia',
    latitude: -31.966703,
    longitude: 115.934942,
    radius: 20,
  },
  {
    location_id: 664,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bunbury',
    address: '135 Ocean Drive, BUNBURY WA 6230, Australia',
    latitude: -33.336212,
    longitude: 115.626513,
    radius: 25,
  },
  {
    location_id: 665,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Floreat',
    address: 'Unit Cnr The Boulevard and Howtree Place, FLOREAT WA 6014, Australia',
    latitude: -31.936584,
    longitude: 115.7926,
    radius: 25,
  },
  {
    location_id: 666,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Hammond Park',
    address: '2 Macquarie Boulevard, HAMMOND PARK WA 6164, Australia',
    latitude: -32.160314,
    longitude: 115.846041,
    radius: 25,
  },
  {
    location_id: 667,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Yangebup',
    address: '281 Beeliar Drive, YANGEBUP WA 6164, Australia',
    latitude: -32.126966,
    longitude: 115.796886,
    radius: 45,
  },
  {
    location_id: 668,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wannanup',
    address: '8 Rod Court, WANNANUP WA 6210, Australia',
    latitude: -32.60448,
    longitude: 115.640877,
    radius: 25,
  },
  {
    location_id: 669,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Riverton',
    address: 'Unit Shop FF1 14-Feb Willeri Drive, PARKWOOD WA 6147, Australia',
    latitude: -32.03908,
    longitude: 115.906226,
    radius: 30,
  },
  {
    location_id: 671,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Harvey',
    address: 'Cnr Young and Roy Street, HARVEY WA 6220, Australia',
    latitude: -33.075642,
    longitude: 115.894767,
    radius: 75,
  },
  {
    location_id: 672,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Attadale',
    address: '6 Hislop Road, ATTADALE WA 6156, Australia',
    latitude: -32.031365,
    longitude: 115.806445,
    radius: 12,
  },
  {
    location_id: 673,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Dalyellup ',
    address: 'Lot 9039 Portobello Road, DALYELLUP WA 6230, Australia',
    latitude: -33.399555,
    longitude: 115.633825,
    radius: 30,
  },
  {
    location_id: 674,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Currambine',
    address: '14 Hobsons Gate, CURRAMBINE WA 6028, Australia',
    latitude: -31.738725,
    longitude: 115.738275,
    radius: 35,
  },
  {
    location_id: 675,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Treendale',
    address: '8 The Promenade, AUSTRALIND WA 6233, Australia',
    latitude: -33.283368,
    longitude: 115.739704,
    radius: 40,
  },
  {
    location_id: 676,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: "O'Connor",
    address: "398 South Street, O'CONNOR WA 6163, Australia",
    latitude: -32.117866,
    longitude: 115.914177,
    radius: 35,
  },
  {
    location_id: 677,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kalgoorlie',
    address: '400 Hannan Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.751504,
    longitude: 121.467682,
    radius: 25,
  },
  {
    location_id: 678,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wellard',
    address: '21 Chiswick Parade, WELLARD WA 6170, Australia',
    latitude: -32.263563,
    longitude: 115.816707,
    radius: 25,
  },
  {
    location_id: 679,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Secret Harbour',
    address: 'Shop 141 Secret Harbour Shopping Centre, SECRET HARBOUR WA 6173, Australia',
    latitude: -32.408662,
    longitude: 115.758578,
    radius: 25,
  },
  {
    location_id: 680,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Moora',
    address: '123 Gardiner Street, MOORA WA 6510, Australia',
    latitude: -30.638598,
    longitude: 116.009439,
    radius: 25,
  },
  {
    location_id: 681,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Walliston',
    address: 'Unit Cnr Lawnbrook and Boronia Road, WALLISTON WA 6076, Australia',
    latitude: -32.000243,
    longitude: 116.074577,
    radius: 40,
  },
  {
    location_id: 682,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Innaloo',
    address: '8 Tassels Place, INNALOO WA 6018, Australia',
    latitude: -31.89512,
    longitude: 115.80233,
    radius: 25,
  },
  {
    location_id: 684,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bellevue',
    address: '49 Great Eastern Highway, BELLEVUE WA 6056, Australia',
    latitude: -31.895495,
    longitude: 116.032454,
    radius: 25,
  },
  {
    location_id: 687,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Bassendean',
    address: '25 Old Perth Road, BASSENDEAN WA 6054, Australia',
    latitude: -31.904374,
    longitude: 115.948332,
    radius: 30,
  },
  {
    location_id: 688,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Safety Bay',
    address: '130 Gloucester Crescent, SHOALWATER WA 6169, Australia',
    latitude: -32.303404,
    longitude: 115.704448,
    radius: 45,
  },
  {
    location_id: 690,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'East Fremantle',
    address: '110 Riverside Drive, EAST FREMANTLE WA 6158, Australia',
    latitude: -32.025989,
    longitude: 115.765656,
    radius: 25,
  },
  {
    location_id: 691,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Nabawa',
    address: '3354 Chapman Valley Road, NABAWA WA 6532, Australia',
    latitude: -28.49917,
    longitude: 114.79504,
    radius: 25,
  },
  {
    location_id: 692,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Wundowie ',
    address: '3381 Great Eastern Highway, WUNDOWIE WA 6560, Australia',
    latitude: -31.806335,
    longitude: 116.361812,
    radius: 30,
  },
  {
    location_id: 693,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Leederville',
    address: '742 Newcastle Street, LEEDERVILLE WA 6007, Australia',
    latitude: -31.937154,
    longitude: 115.841618,
    radius: 25,
  },
  {
    location_id: 695,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Kalgoorlie',
    address: '4 Great Eastern Highway, KALGOORLIE WA 6430, Australia',
    latitude: -30.764879,
    longitude: 121.450625,
    radius: 25,
  },
  {
    location_id: 696,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Esperance',
    address: 'Unit 51 The Esplande, ESPERANCE WA 6450, Australia',
    latitude: -33.861332,
    longitude: 121.893439,
    radius: 40,
  },
  {
    location_id: 699,
    venue_id: 'TAB',
    opening_type: 'Pub/Club Tab',
    location_name: 'Northampton',
    address: '238 Hampton Road, NORTHAMPTON WA 6535, Australia',
    latitude: -28.34862,
    longitude: 114.63182,
    radius: 30,
  },
  {
    location_id: 790,
    venue_id: 'TAB',
    opening_type: 'Account Betting Centre',
    location_name: 'Scan My Bet',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0.0,
    longitude: 0.0,
    radius: 25,
  },
  // --- TODO; TEST DATA BELOW THIS LINE SHOULD BE REMOVED ---
  {
    location_id: 1001,
    venue_id: 'TAB',
    opening_type: 'n/a',
    location_name: 'TEST LOCATION (M01)',
    address: 'n/a',
    latitude: -31.869405,
    longitude: 115.816683,
    radius: 25.0,
  },
  {
    location_id: 1002,
    venue_id: 'TAB',
    opening_type: 'n/a',
    location_name: 'TEST LOCATION (S01)',
    address: 'n/a',
    latitude: -31.653574,
    longitude: 115.715811,
    radius: 25.0,
  },
]
